module.exports = __webpack_public_path__ + "4b493b683a89a47f471ab34b38af0f29.pdf";